import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useEffect } from 'react'
import { IApplicationState } from 'Store/types'
import { useDispatch, useSelector } from 'react-redux'
import { setDescription, setSaveWithoutNet } from '../../Actions/reducer'
import { createVisit } from '../../Actions/action'
import { useNavigate } from 'react-router-dom'
import React from 'react'
import TextAreaInput from 'Components/Form/Input/TextAreaInput'
import Icon from 'Components/Icon'
import gregorianDate from 'Utils/gregorianDate'
import { useSettings } from 'Contexts/SettingsContext'
import Const from 'Utils/Consts'
import { ToastErrorBottomLeft } from 'Utils/toastService'
import BottomSheet from 'Components/BottomSheet'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import { useNetStatus } from 'Contexts/NetStatusContext'

const GetDescriptionPage = (props: { handleBack: () => void; isFake: boolean }) => {
  const [t] = useTranslation()
  const { settings } = useSettings()
  const newVisit = useSelector((store: IApplicationState) => store.visits.newVisit)

  const { netStatus } = useNetStatus()
  const [saveWithoutNetModalVisible, setSaveWithoutNetModalVisible] = React.useState<boolean>(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
    handleSubmit,
    setFocus,
    setValue,
    watch,
    control,
    register,
    formState: { errors },
  } = useForm({ mode: 'onChange' })

  useEffect(() => {
    setFocus('description')
    setValue('description', newVisit.description)
  }, [])

  useEffect(() => {
    dispatch(setDescription(watch('description')))
  }, [watch('description')])

  //"insurance-unit-department-id"
  //"Iic-Karshenas-ID"
  const generateValidNationalCode = () => {
    const randomDigits = Array.from({ length: 9 }, () => Math.floor(Math.random() * 10))
    let sum = randomDigits.reduce((acc, digit, index) => acc + digit * (10 - index), 0)
    let remainder = sum % 11
    let checkDigit = remainder < 2 ? remainder : 11 - remainder
    return randomDigits.join('') + checkDigit.toString()
  }

  const allowedPlateChars = ['ب', 'ج', 'د', 'س', 'ص', 'ط', 'ل', 'م', 'ن', 'و', 'ه', 'ی']

  const generateValidPlate = () => {
    return {
      plateCarOtherNumber: Math.floor(10 + Math.random() * 90).toString(), // ۲ رقمی
      plateCarSerial: Math.floor(100 + Math.random() * 900).toString(), // ۳ رقمی
      plateChar: allowedPlateChars[Math.floor(Math.random() * allowedPlateChars.length)], // حرف معتبر
      plateCityCode: (10 + Math.floor(Math.random() * 80)).toString(), // کد شهر مثل 11، 22، 66
    }
  }

  const submitForm = async (data: any) => {
    dispatch(setDescription(data.description))

    if (netStatus != 'ON') {
      ToastErrorBottomLeft(t('CONNECTION_ERROR'))
      setSaveWithoutNetModalVisible(true)
      return
    }

    if (
      (newVisit.vehicleVisitingPoints.videoStatus != 1 &&
        !newVisit.vehicleVisitingPoints.skipVideo) ||
      (newVisit.customerDeliberately.nationalCard != undefined &&
        newVisit.customerDeliberately.nationalCard.status != 1) ||
      (newVisit.customerDeliberately.nationalCardBack != undefined &&
        newVisit.customerDeliberately.nationalCardBack.status != 1) ||
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
        newVisit.customerDeliberately.vehicleCard != undefined &&
        newVisit.customerDeliberately.vehicleCard.status != 1) ||
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD' &&
        newVisit.customerDeliberately.nationalCardBack != undefined &&
        newVisit.customerDeliberately.nationalCardBack.status != 1) ||
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC' &&
        newVisit.customerDeliberately.vehicleDoc != undefined &&
        newVisit.customerDeliberately.vehicleDoc.status != 1) ||
      (newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC' &&
        newVisit.customerDeliberately.vehicleCompanyDoc != undefined &&
        newVisit.customerDeliberately.vehicleCompanyDoc.status != 1) ||
      newVisit.vehicleVisitingPoints.data.some(x => x.status != 1) ||
      newVisit.notHealthyAutoParts.data.some(x => x.status != 1) ||
      newVisit.vehicleAccessories.data.some(x => x.status != 1)
    ) {
      ToastErrorBottomLeft(t('FILES_IS_NOT_UPLOADED'))
      setSaveWithoutNetModalVisible(true)
      return
    }

    if (props.isFake) {
      const fakeData = JSON.parse(String(settings?.AI_FAKE_DATA))
      const fakePlate = generateValidPlate()
      dispatch(
        createVisit({
          data: {
            visitDate: gregorianDate(newVisit.createTime),
            // cityId: newVisit.customerInfo?.visitLocationType == 1 ? newVisit.customerInfo.cityId : null,
            insuranceTypeId: fakeData?.insuranceTypeId || 984,
            issuanceReasonVisitId: fakeData?.issuanceReasonVisitId || 43,
            personType: 1,
            nationalityID: newVisit.customerInfo.nationalityID,
            firstName: 'بهنام',
            lastName: 'قاسمی',
            identityCode: '0011875488',
            birthDate: '1990-05-06T00:00:00',
            gender: 0,
            mobilePhoneNumber: '09356600703',
            plateType: 1,
            plateCityCode: fakePlate.plateCityCode,
            plateChar: fakePlate.plateChar,
            plateCarSerial: fakePlate.plateCarSerial,
            plateCarOtherNumber: fakePlate.plateCarOtherNumber,
            plateMotorCycleSerial: '',
            plateMotorCycleOtherNumber: '',
            vehicleTypeId: fakeData?.vehicleTypeId || 19,
            vehicleBrandId: fakeData?.vehicleBrandId || 20303,
            vehicleTipId: fakeData?.vehicleTipId || 27323,
            vehicleColorId: fakeData?.vehicleColorId || 247,
            vehicleUsageId: fakeData?.vehicleUsageId || 205,
            vehicleStatus: 1,
            numberOfCylinders: 6,
            yearOfConstruction: 1398,
            vehicleMileage: 250000,
            chassisNumber: 'NAAN01CE0KH516357',
            engineNumber: '124K1369014',
            VIN: null,
            price: 10000000000,
            totalValue: 10002500000,
            towingValue: 0,
            description: 'توضیحات ندارد',
            cargoCompartmentId: fakeData.cargoCompartmentId?.value,
            videoId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.vehicleVisitingPoints.videoFileId,
            videoHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFile
                : null,
            videoHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFileType
                : null,
            videoHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFileExtension
                : null,
            videoHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFileSize
                : null,
            nationalCardId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.nationalCard?.fileId,
            nationalCardHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFile
                : null,
            nationalCardHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFileType
                : null,
            nationalCardHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFileExtension
                : null,
            nationalCardHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFileSize
                : null,
            nationalCardBackId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.nationalCardBack?.fileId,
            nationalCardBackHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFile
                : null,
            nationalCardBackHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFileType
                : null,
            nationalCardBackHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFileExtension
                : null,
            nationalCardBackHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFileSize
                : null,
            vehicleDeliberatelyType:
              newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? 1
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? 2
                  : 3,
            vehicleCardId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.fileId
                  : null,
            vehicleCardHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFile
                  : null
                : null,
            vehicleCardHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFileType
                  : null
                : null,
            vehicleCardHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFileExtension
                  : null
                : null,
            vehicleCardHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFileSize
                  : null
                : null,
            vehicleCardBackId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.fileId
                  : null,
            vehicleCardBackHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFile
                  : null
                : null,
            vehicleCardBackHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFileType
                  : null
                : null,
            vehicleCardBackHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFileExtension
                  : null
                : null,
            vehicleCardBackHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFileSize
                  : null
                : null,
            vehicleDocId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.fileId
                  : null,
            vehicleDocHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFile
                  : null
                : null,
            vehicleDocHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFileType
                  : null
                : null,
            vehicleDocHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFileExtension
                  : null
                : null,
            vehicleDocHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFileSize
                  : null
                : null,
            vehicleCompanyDocId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.fileId
                  : null,
            vehicleCompanyDocHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFile
                  : null
                : null,
            vehicleCompanyDocHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileType
                  : null
                : null,
            vehicleCompanyDocHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileExtension
                  : null
                : null,
            vehicleCompanyDocHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileSize
                  : null
                : null,
            visitLocationType: 2,
            latitude: null,
            longitude: null,
            address: 'در محل واحد صدور',

            dispatchLocation: 'در محل واحد صدور',
            maritalStatus: 1,
            birthPlace: 'AAAAAA',
            placeOfIssue: 'AAAAAA',
            fatherName: 'AAAAA',
            checkCivilRegistry: false,
            isPodSpaceEnable: newVisit.storeFileType == 'POD_SPACE',

            visitVehicleOptionDetailIds: fakeData?.visitVehicleOptionDetailIds || [9, 1, 7, 17],
            visitVehicleVisitingPoints: newVisit.vehicleVisitingPoints.data.map(x => {
              return {
                vehicleVisitingPointId: x.id,
                visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                description: '',
              }
            }),
            visitAutoParts: newVisit.notHealthyAutoParts.data.map(x => {
              return {
                autoPartId: x.id,
                visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                isHealthy: false,
                description: x.description,
                damagePercent: 0,
                amountOfDamages: 0,
              }
            }),
            visitVehicleAccessories: newVisit.vehicleAccessories.data.map(x => {
              return {
                vehicleAccessoryId: x.id,
                visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                accessoryValue: x.price,
                description: x.description,
              }
            }),
          },
          navigate,
        }),
      )
    } else {
      dispatch(
        createVisit({
          data: {
            visitDate: gregorianDate(newVisit.createTime),
            cityId:
              newVisit.customerInfo?.visitLocationType == 1 ? newVisit.customerInfo.cityId : null,
            insuranceTypeId: 984,
            issuanceReasonVisitId: 43,
            personType: newVisit.customerInfo.personType,
            nationalityID: newVisit.customerInfo.nationalityID,
            firstName: newVisit.customerInfo.firstName,
            lastName: newVisit.customerInfo.lastName,
            identityCode: newVisit.customerInfo.identityCode,
            birthDate: newVisit.customerInfo.birthDate,
            gender: newVisit.customerInfo.gender,
            mobilePhoneNumber: newVisit.customerInfo.mobilePhoneNumber,
            plateType:
              newVisit.carInfo.plate?.type === 'UNDEFINED'
                ? 100
                : newVisit.carInfo.plate?.type === 'CAR'
                  ? 1
                  : newVisit.carInfo.plate?.type === 'MOTOR_CYCLE'
                    ? 2
                    : newVisit.carInfo.plate?.type === 'TEMPORARY'
                      ? 4
                      : newVisit.carInfo.plate?.type === 'FREEZONE'
                        ? 3
                        : null,
            plateCityCode:
              newVisit.carInfo.plate?.cityCode || newVisit.carInfo.plate?.serialPlate?.value,
            plateChar: newVisit.carInfo.plate?.char,
            plateCarSerial: newVisit.carInfo.plate?.carSerial,
            plateCarOtherNumber: newVisit.carInfo.plate?.carOtherNumber,
            plateMotorCycleSerial: newVisit.carInfo.plate?.motorCycleSerial,
            PlateSerialId: newVisit.carInfo.plate?.serialPlate?.id,
            plateAdditionalNumber:
              newVisit.carInfo.plate?.englishNumber ||
              newVisit.carInfo.plate?.motorCycleOtherNumber,
            vehicleTypeId: newVisit.carInfo.vehicleTypeId,
            vehicleBrandId: newVisit.carInfo.vehicleBrandId,
            vehicleTipId: newVisit.carInfo.vehicleTipId,
            cargoCompartmentId: newVisit.carInfo.cargoCompartmentId,
            vehicleColorId: newVisit.carInfo.vehicleColorId,
            vehicleUsageId: newVisit.carInfo.vehicleUsageId,
            vehicleStatus: Number(newVisit.carInfo.vehicleStatus) - 1,
            numberOfCylinders: newVisit.carInfo.numberOfCylinders,
            yearOfConstruction: newVisit.carInfo.yearOfConstruction,
            vehicleMileage: Number(String(newVisit.carInfo.vehicleMileage).replace(/,/g, '')),
            chassisNumber: newVisit.carInfo.chassisNumber,
            engineNumber: newVisit.carInfo.engineNumber,
            VIN: newVisit.carInfo.VIN,
            price: newVisit.prices.price,
            totalValue: newVisit.prices.totalValue,
            towingValue: newVisit.prices.towingValue,
            description: data.description,

            videoId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.vehicleVisitingPoints.videoFileId,
            videoHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFile
                : null,
            videoHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFileType
                : null,
            videoHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFileExtension
                : null,
            videoHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.vehicleVisitingPoints.videoHashFileSize
                : null,
            nationalCardId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.nationalCard?.fileId,
            nationalCardHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFile
                : null,
            nationalCardHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFileType
                : null,
            nationalCardHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFileExtension
                : null,
            nationalCardHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCard?.hashFileSize
                : null,
            nationalCardBackId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.nationalCardBack?.fileId,
            nationalCardBackHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFile
                : null,
            nationalCardBackHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFileType
                : null,
            nationalCardBackHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFileExtension
                : null,
            nationalCardBackHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.nationalCardBack?.hashFileSize
                : null,
            vehicleDeliberatelyType:
              newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? 1
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? 2
                  : 3,
            vehicleCardId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.fileId
                  : null,
            vehicleCardHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFile
                  : null
                : null,
            vehicleCardHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFileType
                  : null
                : null,
            vehicleCardHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFileExtension
                  : null
                : null,
            vehicleCardHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCard?.hashFileSize
                  : null
                : null,
            vehicleCardBackId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.fileId
                  : null,
            vehicleCardBackHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFile
                  : null
                : null,
            vehicleCardBackHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFileType
                  : null
                : null,
            vehicleCardBackHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFileExtension
                  : null
                : null,
            vehicleCardBackHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? newVisit.customerDeliberately.vehicleCardBack?.hashFileSize
                  : null
                : null,
            vehicleDocId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.fileId
                  : null,
            vehicleDocHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFile
                  : null
                : null,
            vehicleDocHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFileType
                  : null
                : null,
            vehicleDocHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFileExtension
                  : null
                : null,
            vehicleDocHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? newVisit.customerDeliberately.vehicleDoc?.hashFileSize
                  : null
                : null,
            vehicleCompanyDocId:
              newVisit.storeFileType == 'POD_SPACE'
                ? null
                : newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.fileId
                  : null,
            vehicleCompanyDocHashFile:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFile
                  : null
                : null,
            vehicleCompanyDocHashFileType:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileType
                  : null
                : null,
            vehicleCompanyDocHashFileExtension:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileExtension
                  : null
                : null,
            vehicleCompanyDocHashFileSize:
              newVisit.storeFileType == 'POD_SPACE'
                ? newVisit.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? newVisit.customerDeliberately.vehicleCompanyDoc?.hashFileSize
                  : null
                : null,
            visitLocationType: newVisit.customerInfo?.visitLocationType,
            latitude:
              newVisit.customerInfo?.visitLocationType == 1
                ? newVisit.customerInfo.location?.latitude
                : null,
            longitude:
              newVisit.customerInfo?.visitLocationType == 1
                ? newVisit.customerInfo.location?.longitude
                : null,
            address:
              newVisit.customerInfo?.visitLocationType == 1
                ? newVisit.customerInfo.location?.address
                : 'در محل واحد صدور',

            dispatchLocation:
              newVisit.customerInfo?.visitLocationType == 1
                ? newVisit.customerInfo.location?.address
                : 'در محل واحد صدور',
            maritalStatus: 1,
            birthPlace: 'AAAAAA',
            placeOfIssue: 'AAAAAA',
            fatherName: 'AAAAA',
            checkCivilRegistry: false,
            isPodSpaceEnable: newVisit.storeFileType == 'POD_SPACE',
            branchCode: newVisit.customerInfo.branchCode,
            draftVisitId: newVisit.draftVisitId,

            visitVehicleOptionDetailIds: newVisit.vehicleOptions.map(x => {
              return x.vehicleOptionDetailId
            }),
            visitVehicleVisitingPoints: newVisit.vehicleVisitingPoints.data.map(x => {
              return {
                vehicleVisitingPointId: x.id,
                visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                description: '',
              }
            }),
            visitAutoParts: newVisit.notHealthyAutoParts.data.map(x => {
              return {
                autoPartId: x.id,
                visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                isHealthy: false,
                description: x.description,
                damagePercent: 0,
                amountOfDamages: 0,
              }
            }),
            visitVehicleAccessories: newVisit.vehicleAccessories.data.map(x => {
              return {
                vehicleAccessoryId: x.id,
                visitFileId: newVisit.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: newVisit.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  newVisit.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: newVisit.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                accessoryValue: x.price,
                description: x.description,
              }
            }),
          },
          navigate,
        }),
      )
    }
  }

  const isLoading = newVisit.loading // || newVisit.createVisitErrorLog.loading

  return (
    <React.Fragment>
      <div className={`flex flex-col grow overflow-auto${isLoading ? ' loading' : ''}`}>
        <div className="px-6 pb-6">
          <div className="text-sm mb-8">{t("ENTER-THE-EXPERT'S-COMMENTS-AND-OPINION")}</div>

          <div className="space-y-4">
            <form>
              <TextAreaInput
                id="description"
                name="description"
                register={register}
                rows={10}
                label={t('DESCRIPTION')}
                errors={errors.description}
                rules={{
                  maxLength: 500,
                }}
              />
            </form>
          </div>
        </div>
      </div>

      <BottomSheet
        title=""
        visible={saveWithoutNetModalVisible}
        onCancel={() => setSaveWithoutNetModalVisible(false)}
      >
        <div
          style={{
            width: 50,
            height: 6,
            backgroundColor: '#ccc',
            borderRadius: 3,
            position: 'absolute',
            top: 8,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />

        <div className="overflow-auto px-6 pb-6">
          <div className="text-black text-sm mb-4">{t('SAVE_WITHOUT_NET_MESSAGE')}</div>
        </div>
        <div className="cta flex flex-col gap-4">
          <button
            type="button"
            className="btn btn-primary btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={() => {
              dispatch(setSaveWithoutNet(true))
              setSaveWithoutNetModalVisible(false)
              navigate(VisitsPaths.VisitsMain)
            }}
          >
            {t('SAVE')}
          </button>
          <button
            type="button"
            className="btn btn-error btn-lg flex items-center justify-center w-full"
            disabled={false}
            onClick={() => {
              setSaveWithoutNetModalVisible(false)
            }}
          >
            {t('CANCEL')}
          </button>
        </div>
      </BottomSheet>

      <div className="cta">
        <div className="flex justify-between items-center gap-2">
          <button
            className="btn btn-warning btn-lg flex gap-2 items-center justify-center w-full"
            disabled={isLoading}
            onClick={props.handleBack}
          >
            <Icon name="arrow-right" className="w-6 h-6" />
            {t('BACK')}
          </button>
          <button
            className="btn btn-primary btn-lg flex gap-2 items-center justify-center w-full"
            disabled={isLoading}
            onClick={handleSubmit(submitForm)}
          >
            {t('SAVE')}
            <Icon name="arrow-left" className="w-6 h-6" />
          </button>
        </div>
      </div>
    </React.Fragment>
  )
}

export default GetDescriptionPage
